import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";
import { useLocation } from "react-router-dom";


export default function Calendar() {
  const location = useLocation();
  const { 
    activeSeriesName, setActiveSeriesName,
    activeSeriesRef, setActiveSeriesRef,
  } = useContext(GlobalContext);
  // const [activeHref, setActiveHref] = useState("/news");

  // console.log(location.pathname === "/news")


  return (
    <>
      <SpaceBetween direction="horizontal" size="xl">
        <Container header={<Header variant="h1"> {`${activeSeriesName} Series Calendar`} </Header>}>
          <img
            src={`/images/${activeSeriesRef}/${activeSeriesRef}-calendar.png`}
            alt={`${activeSeriesName} Series Calendar`}
            width={"100%"}
          />
        </Container>
      </SpaceBetween>
    </>    
  );
}

